(function(){
"use strict";
var ORDER_EMAIL   = "tbowen@flexfactoryice.com";  // where reservations land
var FORM_ENDPOINT   = "";
var FORM_ACCESS_KEY = "";
var AI_ENDPOINT   = "";                   // paste your own chat API URL to power the assistant on your own host
var BUILD = "2026-09-06.9";
var SHOP_DOMAIN = "flexxfactoryyy.myshopify.com";
var SHOP_BASE = (typeof location!=="undefined" && /(^|\.)flexfactoryice\.com$|\.myshopify\.com$/i.test(location.hostname||"")) ? "" : "https://"+SHOP_DOMAIN;
var VARIANTS = {
  honeycomb: {1:50577629446387,2:50577629479155,3:50980007772403,4:50577629511923,5:50980007805171,6:50577629544691,7:50980007837939,8:50577629577459,9:50980007870707,10:50577629610227,11:50980007903475,12:50577629642995,13:50980007936243,14:50980007969011,15:50980008001779,16:50577629675763,17:50980008034547,18:50980008067315,19:50980008100083,20:50577629708531},
  galaxy: {1:50577605132531,2:50577605165299,3:50980008132851,4:50577605198067,5:50980008165619,6:50577605230835,7:50980008198387,8:50577605263603,9:50980008231155,10:50577605296371,11:50980008263923,12:50577605329139,13:50980008296691,14:50980008329459,15:50980008362227,16:50577605361907,17:50980008394995,18:50980008427763,19:50980008460531,20:50577605394675},
  mosaic: {1:50577578295539,2:50577578328307,3:50980008493299,4:50577578361075,5:50980008526067,6:50577578393843,7:50980008558835,8:50577578426611,9:50980008591603,10:50577578459379,11:50980008624371,12:50577578492147,13:50980008657139,14:50980008689907,15:50980008722675,16:50577578524915,17:50980008755443,18:50980008788211,19:50980008820979,20:50577578557683},
  baguette: {1:50980013834483,2:50980013867251,3:50980013900019,4:50980013932787,5:50980013965555,6:50980013998323,7:50980014031091,8:50980014063859,9:50980014096627,10:50980014129395,11:50980014162163,12:50980014194931,13:50980014227699,14:50980014260467,15:50980014293235,16:50980014326003,17:50980014358771,18:50980014391539,19:50980014424307,20:50980014457075}
};
var SETTINGS = [
  {
    id:"honeycomb", name:"Honeycomb", full:"Honeycomb Setting",
    blurb:"Stones set in a hexagonal lattice that locks together edge to edge. Almost no metal shows between them, so the surface reads as one solid sheet of ice.",
    why:"The tightest packing geometry there is. Structural, symmetrical, zero gaps.",
    feats:["Hexagonal lattice, wall-to-wall coverage","Stones set flush for a smooth finish","The cleanest and most uniform of the four"],
    tiers:{1:150,2:275,4:450,6:650,8:850,10:1050,12:1200,16:1400,20:1600}
  },
  {
    id:"galaxy", name:"Galaxy", full:"Galaxy Setting",
    blurb:"Stones clustered at varying sizes and depths, like a starfield. Because they sit at different heights, the sparkle moves as you move.",
    why:"Layered depth gives a 3D flash that flat settings can't produce.",
    feats:["Multi-size stone clusters","Dimensional, depth-layered sparkle","Catches light dynamically from every angle"],
    tiers:{1:150,2:300,4:475,6:700,8:900,10:1100,12:1300,16:1500,20:1700}
  },
  {
    id:"mosaic", name:"Mosaic", full:"Mosaic Setting",
    blurb:"A dense field of fine pavé built around one large centre stone, ringed by a hand-set halo on every tooth. The metal shows just enough between stones to frame each one.",
    why:"One focal stone per tooth, bedded in graduated pavé.",
    feats:["Large centre stone with a hand-set halo","Fine graduated pavé filling the plate","The most jewellery-like of the four"],
    tiers:{1:200,2:275,4:475,6:675,8:875,10:1050,12:1200,16:1600,20:1800}
  },
  {
    id:"baguette", name:"Baguette", full:"Baguette Setting",
    blurb:"Rectangular step cuts channel-set in rows across the plate, each row divided by its own rail of metal, with a fine round-stone border tracing the edge of every tooth.",
    why:"Straight lines and long flashes instead of scattered sparkle.",
    feats:["Channel-set step cuts in stacked rows","Micro-pavé border framing every plate","Broad, linear flash rather than pinpoint fire"],
    tiers:{}   // derived from Galaxy below
  }
];
(function(){
  var gal,bag,i,k;
  for(i=0;i<SETTINGS.length;i++){
    if(SETTINGS[i].id==="galaxy")   gal=SETTINGS[i];
    if(SETTINGS[i].id==="baguette") bag=SETTINGS[i];
  }
  if(gal&&bag) for(k in gal.tiers) bag.tiers[k]=Math.round(gal.tiers[k]*1.15/5)*5;
})();
var METALS = [
  {id:"gold",  name:"Yellow gold", c:["#F5DA97","#C89320","#8A6415"],
   ramp:["#7A5510","#C9971F","#FBEFC4","#DDB03C","#8E6414","#EBD48A","#6B4A0D"]},
  {id:"white", name:"White gold",  c:["#F4F7FA","#B7C1CB","#78838E"],
   ramp:["#6E7883","#AEB9C4","#FDFEFF","#C6D0DA","#7C8794","#E4EBF2","#616B76"]},
  {id:"rose",  name:"Rose gold",   c:["#F7CDB6","#D18C6D","#95533B"],
   ramp:["#8A4A33","#CE8467","#FDE3D5","#E0A184","#9A5940","#F2C4AC","#7A3F2B"]}
];
function T(k,n,w,h,shape){ return {k:k,name:n,w:w,h:h,shape:shape}; }
var U_ROW = [
  T("pm2","2nd premolar",7.0, 7.5,"pm"),  T("pm1","1st premolar",6.8, 8.5,"pm"),
  T("can","canine",      7.6,10.0,"can"), T("lat","lateral incisor",6.5,9.0,"inc"),
  T("cen","central incisor",8.5,10.5,"inc"),
  T("cen","central incisor",8.5,10.5,"inc"),
  T("lat","lateral incisor",6.5,9.0,"inc"), T("can","canine",7.6,10.0,"can"),
  T("pm1","1st premolar",6.8, 8.5,"pm"),  T("pm2","2nd premolar",7.0,7.5,"pm")
];
var L_ROW = [
  T("pm2","2nd premolar",7.1, 8.0,"pm"),  T("pm1","1st premolar",7.0, 8.5,"pm"),
  T("can","canine",      6.7,11.0,"can"), T("lat","lateral incisor",5.7,9.5,"inc"),
  T("cen","central incisor",5.3,9.0,"inc"),
  T("cen","central incisor",5.3,9.0,"inc"),
  T("lat","lateral incisor",5.7,9.5,"inc"), T("can","canine",6.7,11.0,"can"),
  T("pm1","1st premolar",7.0, 8.5,"pm"),  T("pm2","2nd premolar",7.1,8.0,"pm")
];
var UPPER_N = [4,5,6,7,8,9,10,11,12,13];
var LOWER_N = [29,28,27,26,25,24,23,22,21,20];
var FAQ = [
  ["Do I need to go to a dentist?","No. The kit does what the dentist chair does — it captures the shape of your teeth. The putty we send is the same class of dental impression silicone a lab works from. Most people get a clean impression on the first try, and we send enough putty for two attempts."],
  ["Is moissanite the same as diamond?","No, and we won't tell you it is. Moissanite is silicon carbide. It's 9.25 on the Mohs scale against diamond's 10, so it's plenty hard for daily wear, and it actually throws <b>more</b> colored fire than diamond because its dispersion is higher — 0.104 against diamond's 0.044. That rainbow flash you see off a moissanite set is the whole point. It costs a fraction of what diamond does, which is why the pieces are affordable."],
  ["How long does the whole thing take?","Six to eight weeks on the bench from the day your impression reaches us, plus the mail: five to eight business days for the kit to reach you, about the same for it to come back, and five to eight business days shipping the finished set. If you're on a deadline — a shoot, a wedding, a birthday — say so when you order and we'll tell you honestly whether it's doable rather than promising a date we'd miss."],
  ["What if the fit is wrong?","We re-cut it, no charge. That's the trade you get for taking an impression instead of buying a pre-formed tray. If the impression itself came out unusable we'll mail you a fresh kit rather than guess at your arch."],
  ["Can I eat and drink with them in?","Drink water, yes. Eat, no. Take them out for meals and for sleeping. Food packs under the plate and against your gums, and that's how people end up with irritation — it's the food, not the metal."],
  ["How do I clean them?","Warm water, a soft toothbrush, and a drop of unscented dish soap. Brush the inside as well as the face, rinse, and dry them fully before they go back in the case. No boiling water, no bleach, no ultrasonic cleaner, no alcohol — all four can loosen the stone settings."],
  ["Do you ship outside the US?","Yes, but the price shown here covers US shipping only. International orders pay actual postage both ways plus any duties on their end. Message the assistant with your country and we'll quote it before you commit."],
  ["When do I pay?","At checkout. You build your set, tick the terms, and go straight to Shopify’s secure checkout — card, Shop Pay, Apple Pay or Google Pay. Flex Factory never sees your card details.\n\nYou still get photographs of the finished set before it ships."],
  ["Can I do just one tooth?","Yes, as a custom order — single caps start at $150. The 3D studio starts at two teeth, so ask for a single cap through the Custom Order page. A single canine or a single central are the two most requested. You still take a full-arch impression so the cap seats against the neighbouring teeth correctly."]
];
function $(s,r){return (r||document).querySelector(s);}
function el(t,a,h){var e=document.createElementNS("http://www.w3.org/2000/svg",t);for(var k in a)e.setAttribute(k,a[k]);if(h)e.innerHTML=h;return e;}
function money(n){return "$"+n.toLocaleString("en-US",{minimumFractionDigits:(n%1?2:0),maximumFractionDigits:2});}
function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];});}
function rng(seed){var s=seed;return function(){s=(s*1664525+1013904223)%4294967296;return s/4294967296;};}
function metal(id){for(var i=0;i<METALS.length;i++) if(METALS[i].id===id) return METALS[i];return METALS[0];}
function setting(id){for(var i=0;i<SETTINGS.length;i++) if(SETTINGS[i].id===id) return SETTINGS[i];return SETTINGS[0];}
function priceFor(tiers,n){
  if(n<=0) return 0;
  var ks=Object.keys(tiers).map(Number).sort(function(a,b){return a-b;});
  if(tiers[n]!=null) return tiers[n];
  if(n<ks[0]) return tiers[ks[0]];
  if(n>ks[ks.length-1]) return tiers[ks[ks.length-1]];
  var lo=ks[0],hi=ks[ks.length-1];
  for(var i=0;i<ks.length-1;i++){ if(n>ks[i]&&n<ks[i+1]){lo=ks[i];hi=ks[i+1];break;} }
  var t=(n-lo)/(hi-lo);
  return Math.round((tiers[lo]+(tiers[hi]-tiers[lo])*t)/5)*5;
}
function stoneTile(kind,idp){
  var g="",r,i,j,x,y;
  function fire(rnd,W,H,n){
    var hues=["#5BE3F0","#8E7CF6","#FFC24D","#6FE9A8"], o="", q;
    for(q=0;q<n;q++) o+='<circle cx="'+(rnd()*W).toFixed(2)+'" cy="'+(rnd()*H).toFixed(2)
      +'" r="'+(0.55+rnd()*0.7).toFixed(2)+'" fill="'+hues[q%hues.length]+'" opacity=".85"/>';
    return o;
  }
  function stone(cx,cy,rad){
    return '<circle cx="'+cx.toFixed(2)+'" cy="'+cy.toFixed(2)+'" r="'+rad.toFixed(2)+'" '
         + 'fill="url(#ice-'+idp+')" stroke="#221A10" stroke-width="'+(rad*0.16).toFixed(2)+'" stroke-opacity=".55"/>'
         + '<circle cx="'+(cx-rad*0.30).toFixed(2)+'" cy="'+(cy-rad*0.34).toFixed(2)+'" r="'+(rad*0.26).toFixed(2)+'" '
         + 'fill="#FFFFFF" opacity=".92"/>';
  }
  if(kind==="honeycomb"){
    var pts=[[0,0],[6.6,0],[13.2,0],[3.3,5.7],[9.9,5.7],[0,11.4],[6.6,11.4],[13.2,11.4]];
    for(i=0;i<pts.length;i++) g+=stone(pts[i][0],pts[i][1],3.05,".38");
    g+=fire(rng(41),13.2,11.4,1);
    return {w:13.2,h:11.4,body:g};
  }
  if(kind==="galaxy"){
    r=rng(97); var used=[], attempts=0;
    g+='<rect width="30" height="30" fill="#0F0D0B" opacity=".34"/>';   // metal reads dark between the stones
    while(used.length<58 && attempts++<1400){
      x=r()*30; y=r()*30;
      var rad=0.72+Math.pow(r(),1.9)*3.6;      // many small, a few big
      var ok=true;
      for(j=0;j<used.length;j++){var dx=used[j][0]-x,dy=used[j][1]-y;if(Math.sqrt(dx*dx+dy*dy)<rad+used[j][2]+0.16){ok=false;break;}}
      if(!ok) continue;
      used.push([x,y,rad]);
      g+=stone(x,y,rad);
    }
    g+=fire(r,30,30,7);
    return {w:30,h:30,body:g};
  }
  if(kind==="mosaic"){
    r=rng(311); var placed=[], step=5.4;
    for(i=0;i<5;i++) for(j=0;j<5;j++){
      var mx=i*step+(j%2)*step/2+(r()-0.5)*0.9, my=j*step*0.88+(r()-0.5)*0.9;
      var mr=2.05+r()*0.75;
      g+=stone(mx,my,mr);
      placed.push([mx,my,mr]);
    }
    for(i=0;i<10;i++) g+='<circle cx="'+(r()*27).toFixed(2)+'" cy="'+(r()*24).toFixed(2)+'" r="0.7" fill="#FFF2CE" opacity=".55"/>';
    g+=fire(r,27,22,4);
    return {w:27,h:22,body:g};
  }
  if(kind==="baguette"){
    r=rng(59); var bp=[], bt=0;
    while(bp.length<34 && bt++<800){
      x=r()*16; y=r()*16; var br=0.82+r()*0.34;
      var okb=true;
      for(j=0;j<bp.length;j++){var ddx=bp[j][0]-x,ddy=bp[j][1]-y;if(Math.sqrt(ddx*ddx+ddy*ddy)<br+bp[j][2]+0.22){okb=false;break;}}
      if(!okb) continue;
      bp.push([x,y,br]); g+=stone(x,y,br);
    }
    g+=fire(r,16,16,2);
    return {w:16,h:16,body:g};
  }
  return {w:10,h:10,body:""};
}
function defsFor(idp,kinds){
  var d='<radialGradient id="ice-'+idp+'" cx="34%" cy="28%" r="76%">'
       + '<stop offset="0%" stop-color="#FFFFFF"/>'
       + '<stop offset="24%" stop-color="#F7FCFF"/>'
       + '<stop offset="56%" stop-color="#D6E6F4"/>'
       + '<stop offset="82%" stop-color="#A9BFD3"/>'
       + '<stop offset="100%" stop-color="#F0F7FF"/></radialGradient>';
  for(var m=0;m<METALS.length;m++){
    var M=METALS[m], off=["0%","14%","30%","44%","62%","80%","100%"], k;
    d+='<linearGradient id="m-'+idp+'-'+M.id+'" x1="0.12" y1="0" x2="0.32" y2="1">';
    for(k=0;k<M.ramp.length;k++) d+='<stop offset="'+off[k]+'" stop-color="'+M.ramp[k]+'"/>';
    d+='</linearGradient>';
  }
  for(var i=0;i<kinds.length;i++){
    var t=stoneTile(kinds[i],idp);
    d+='<pattern id="p-'+idp+'-'+kinds[i]+'" patternUnits="userSpaceOnUse" width="'+t.w+'" height="'+t.h+'">'+t.body+'</pattern>';
  }
  d+='<linearGradient id="enamel-'+idp+'" x1="0" y1="0" x2="0" y2="1">'
    +'<stop offset="0%" stop-color="#E3D9C8"/>'
    +'<stop offset="16%" stop-color="#F3EEE3"/>'
    +'<stop offset="52%" stop-color="#FBF9F5"/>'
    +'<stop offset="80%" stop-color="#EEF0F1"/>'
    +'<stop offset="100%" stop-color="#C7D2DA"/></linearGradient>';
  d+='<linearGradient id="side-'+idp+'" x1="0" y1="0" x2="1" y2="0">'
    +'<stop offset="0%" stop-color="#150E08" stop-opacity=".40"/>'
    +'<stop offset="17%" stop-color="#150E08" stop-opacity="0"/>'
    +'<stop offset="83%" stop-color="#150E08" stop-opacity="0"/>'
    +'<stop offset="100%" stop-color="#150E08" stop-opacity=".40"/></linearGradient>';
  d+='<linearGradient id="ao-'+idp+'" x1="0" y1="0" x2="0" y2="1">'
    +'<stop offset="0%" stop-color="#2E1512" stop-opacity=".55"/>'
    +'<stop offset="18%" stop-color="#2E1512" stop-opacity="0"/>'
    +'<stop offset="100%" stop-color="#2E1512" stop-opacity="0"/></linearGradient>';
  d+='<radialGradient id="tbl-'+idp+'" cx="40%" cy="34%" r="70%">'
    +'<stop offset="0%" stop-color="#FFFFFF"/>'
    +'<stop offset="55%" stop-color="#EAF4FE"/>'
    +'<stop offset="100%" stop-color="#BFD3E6"/></radialGradient>';
  d+='<linearGradient id="sweep-'+idp+'" gradientUnits="userSpaceOnUse" x1="-300" y1="120" x2="-60" y2="300">'
    +'<stop offset="0%" stop-color="#FFFFFF" stop-opacity="0"/>'
    +'<stop offset="38%" stop-color="#FFFFFF" stop-opacity=".42"/>'
    +'<stop offset="50%" stop-color="#FFFFFF" stop-opacity=".85"/>'
    +'<stop offset="62%" stop-color="#CFE6FF" stop-opacity=".42"/>'
    +'<stop offset="100%" stop-color="#FFFFFF" stop-opacity="0"/>'
    +'</linearGradient>';
  d+='<filter id="soft-'+idp+'" x="-40%" y="-40%" width="180%" height="180%">'
    +'<feGaussianBlur stdDeviation="2.4"/></filter>';
  return '<defs>'+d+'</defs>';
}
function toothProfile(shape,t){
  var p = t<0.62 ? 0.70+0.30*Math.pow(t/0.62,0.75) : 1;
  if(shape==="can"){ if(t>0.70) p*=Math.max(0,1-Math.pow((t-0.70)/0.32,1.5)); }
  else if(shape==="pm"){ if(t>0.80) p*=Math.sqrt(Math.max(0,1-Math.pow((t-0.80)/0.215,2))); }
  else if(t>0.90) p*=Math.sqrt(Math.max(0,1-Math.pow((t-0.90)/0.105,2)));
  return Math.max(0,p);
}
function featureStones(kind,shape,w,h,seed,idp,metalId){
  if(kind==="honeycomb") return "";        // honeycomb is a uniform field by definition
  if(w<24||h<26) return "";                // too foreshortened to read
  var hw=w/2, R=rng(seed||7), out="", i;
  function gem(cx,cy,rad,flare){
    var o='<circle cx="'+cx.toFixed(2)+'" cy="'+cy.toFixed(2)+'" r="'+rad.toFixed(2)+'" '
         + 'fill="url(#ice-'+idp+')" stroke="#1B140E" stroke-width="'+(rad*0.15).toFixed(2)+'" stroke-opacity=".7"/>';
    var fp="",k,a1,a2,ri=rad*0.44,ro=rad*0.94;
    for(k=0;k<8;k++){
      a1=(k/8)*Math.PI*2; a2=((k+0.5)/8)*Math.PI*2;
      fp+="M"+(cx+Math.cos(a1)*ri).toFixed(2)+","+(cy+Math.sin(a1)*ri).toFixed(2)
        +"L"+(cx+Math.cos(a2)*ro).toFixed(2)+","+(cy+Math.sin(a2)*ro).toFixed(2);
    }
    o+='<path d="'+fp+'" fill="none" stroke="#FFFFFF" stroke-opacity=".40" stroke-width="'+(rad*0.075).toFixed(2)+'"/>'
     + '<circle cx="'+cx.toFixed(2)+'" cy="'+cy.toFixed(2)+'" r="'+(rad*0.44).toFixed(2)+'" fill="url(#tbl-'+idp+')" stroke="#FFFFFF" stroke-opacity=".45" stroke-width="'+(rad*0.05).toFixed(2)+'"/>';
    if(flare){
      var L=rad*1.75, T=rad*0.17;
      o+='<g opacity=".72" fill="#FFFFFF" transform="translate('+cx.toFixed(2)+','+cy.toFixed(2)+')">'
        +'<polygon points="0,'+(-L)+' '+T+',0 0,'+L+' '+(-T)+',0"/>'
        +'<polygon points="'+(-L)+',0 0,'+(-T)+' '+L+',0 0,'+T+'"/>'
        +'</g>';
    }
    return o+'<circle cx="'+(cx-rad*0.30).toFixed(2)+'" cy="'+(cy-rad*0.36).toFixed(2)+'" r="'+(rad*0.26).toFixed(2)+'" fill="#FFFFFF" opacity=".95"/>';
  }
  function bagStone(cx,cy,L,W,deg,flare,simple){
    var o='<g transform="translate('+cx.toFixed(2)+','+cy.toFixed(2)+') rotate('+deg.toFixed(1)+')">'
      + '<rect x="'+(-L/2).toFixed(2)+'" y="'+(-W/2).toFixed(2)+'" width="'+L.toFixed(2)+'" height="'+W.toFixed(2)+'" rx="'+(W*0.10).toFixed(2)+'" '
      +   'fill="url(#ice-'+idp+')" stroke="#171008" stroke-width="'+(W*0.17).toFixed(2)+'" stroke-opacity=".8"/>';
    if(!simple){
      o+= '<rect x="'+(-L*0.36).toFixed(2)+'" y="'+(-W*0.28).toFixed(2)+'" width="'+(L*0.72).toFixed(2)+'" height="'+(W*0.56).toFixed(2)+'" rx="'+(W*0.07).toFixed(2)+'" '
       +   'fill="url(#tbl-'+idp+')" stroke="#FFFFFF" stroke-width="'+(W*0.08).toFixed(2)+'" stroke-opacity=".55"/>'
       +  '<path d="M'+(-L*0.30).toFixed(2)+','+(-W*0.42).toFixed(2)+'V'+(W*0.42).toFixed(2)
       +       'M'+(L*0.30).toFixed(2)+','+(-W*0.42).toFixed(2)+'V'+(W*0.42).toFixed(2)+'" '
       +   'fill="none" stroke="#FFFFFF" stroke-opacity=".34" stroke-width="'+(W*0.07).toFixed(2)+'"/>';
    }
    o+= '<rect x="'+(-L*0.40).toFixed(2)+'" y="'+(-W*0.30).toFixed(2)+'" width="'+(L*0.22).toFixed(2)+'" height="'+(W*0.26).toFixed(2)+'" rx="'+(W*0.06).toFixed(2)+'" fill="#FFFFFF" opacity=".88"/>';
    if(flare){
      var F=L*0.70, TT=W*0.16;
      o+='<g opacity=".6" fill="#FFFFFF"><polygon points="0,'+(-F)+' '+TT+',0 0,'+F+' '+(-TT)+',0"/>'
        +'<polygon points="'+(-F)+',0 0,'+(-TT)+' '+F+',0 0,'+TT+'"/></g>';
    }
    return o+'</g>';
  }
  function inside(x,y,rad){
    var t=y/h;
    if(t<0.06||t>0.96) return false;
    return Math.abs(x) <= hw*toothProfile(shape,t)-rad-w*0.045;
  }
  if(kind==="mosaic"){
    var cy=h*0.46, cr=Math.min(hw*0.34,h*0.15);
    if(!inside(0,cy,cr)) cr=Math.min(cr,hw*toothProfile(shape,cy/h)-w*0.05);
    if(cr<2) return "";
    var hr=cr*0.40, ring=cr+hr+cr*0.14;
    for(i=0;i<9;i++){
      var a=(i/9)*Math.PI*2-Math.PI/2, x=Math.cos(a)*ring, y=cy+Math.sin(a)*ring*0.92;
      if(inside(x,y,hr)) out+=gem(x,y,hr);
    }
    out+=gem(0,cy,cr,true);
    return out;
  }
  if(kind==="baguette"){
    var M=metal(metalId||"white");
    var cw=Math.max(2.4, w*0.116);          // stone width = column width
    var sh=cw*1.85;                          // stones stand taller than they are wide
    var gp=Math.max(0.7, cw*0.17);
    var fw=Math.min(w*0.34, h*0.22), fh=fw*1.18, fy=h*0.505;
    var fx0=-fw/2-gp, fx1=fw/2+gp, fy0=fy-fh/2-gp, fy1=fy+fh/2+gp;
    var ci, cj, x, y, yoff;
    for(ci=0; ; ci++){
      x = -hw + gp + (ci+0.5)*(cw+gp);
      if(x > hw) break;
      yoff = (ci%2) ? (sh+gp)/2 : 0;
      for(cj=0; cj<14; cj++){
        y = h*0.05 + yoff + cj*(sh+gp) + sh/2;
        if(y > h*0.97) break;
        if(x>fx0 && x<fx1 && y>fy0 && y<fy1) continue;              // frame keeps its space
        if(!inside(x, y-sh*0.40, cw*0.52)) continue;                 // both ends must sit
        if(!inside(x, y+sh*0.40, cw*0.52)) continue;                 // inside the crown
        out += bagStone(x, y, sh, cw, 90, false, true);
      }
    }
    out += '<rect x="'+(-fw/2).toFixed(2)+'" y="'+(fy-fh/2).toFixed(2)+'" width="'+fw.toFixed(2)+'" height="'+fh.toFixed(2)+'" '
        +  'rx="'+(fw*0.07).toFixed(2)+'" fill="url(#m-'+idp+'-'+(metalId||"white")+')" stroke="'+M.c[0]+'" stroke-width="'+(fw*0.11).toFixed(2)+'"/>'
        +  '<rect x="'+(-fw/2).toFixed(2)+'" y="'+(fy-fh/2).toFixed(2)+'" width="'+fw.toFixed(2)+'" height="'+fh.toFixed(2)+'" '
        +  'rx="'+(fw*0.07).toFixed(2)+'" fill="none" stroke="#0C0A07" stroke-width="'+(fw*0.035).toFixed(2)+'" stroke-opacity=".8"/>'
        +  bagStone(0, fy, fh*0.80, fw*0.60, 90, true, false);
    return out;
  }
  var n=3+Math.floor(R()*3), placed=[], tries=0, j;
  while(placed.length<n && tries++<80){
    var gr=hw*(0.16+R()*0.12);
    var gx=(R()-0.5)*w*0.80, gy=h*(0.13+R()*0.78);
    if(!inside(gx,gy,gr)) continue;
    if(Math.abs(gx)<w*0.06 && Math.abs(gy-h*0.5)<h*0.10) continue;   // keep it off centre
    var clash=false;
    for(j=0;j<placed.length;j++){
      var dx=placed[j][0]-gx, dy=placed[j][1]-gy;
      if(Math.sqrt(dx*dx+dy*dy) < gr+placed[j][2]+w*0.035){ clash=true; break; }
    }
    if(clash) continue;
    placed.push([gx,gy,gr]);
  }
  for(j=0;j<placed.length;j++) out+=gem(placed[j][0],placed[j][1],placed[j][2], j<2);
  return out;
}
var VURL={};
function vidURL(k){
  var src=window.FF_VIDS&&window.FF_VIDS[k];
  if(!src) return "";
  if(/^(https?:)?\/\//.test(src) || src.charAt(0)==="/") return src;
  if(!VURL[k]){
    try{
      var bin=atob(src), n=bin.length, arr=new Uint8Array(n), i;
      for(i=0;i<n;i++) arr[i]=bin.charCodeAt(i);
      VURL[k]=URL.createObjectURL(new Blob([arr],{type:(window.FF_VID_MIME||"video/mp4")}));
    }catch(e){ VURL[k]="data:"+(window.FF_VID_MIME||"video/mp4")+";base64,"+src; }
  }
  return VURL[k];
}
var REDUCE = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
var VIO = (!REDUCE && "IntersectionObserver" in window) ? new IntersectionObserver(function(es){
  es.forEach(function(e){
    if(e.isIntersecting){ var p=e.target.play(); if(p&&p.catch) p.catch(function(){}); }
    else e.target.pause();
  });
},{rootMargin:"150px"}) : null;
function mountWatchHero(host){
  if(!host) return null;
  var base=(window.FF_ASSET_BASE||"");
  var v=document.createElement("video");
  v.className="pvid";
  v.muted=true; v.loop=true; v.playsInline=true;
  v.setAttribute("muted",""); v.setAttribute("playsinline",""); v.setAttribute("loop","");
  v.preload="auto";
  v.setAttribute("aria-label","Iced watch turning");
  if(REDUCE) v.controls=true;
  v.src=base+"watch-hero.mp4";
  host.insertBefore(v,host.firstChild);
  if(VIO) VIO.observe(v); else if(!REDUCE){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
  return v;
}
function mountVideo(host,key,label){
  var url=vidURL(key);
  if(!host||!url) return null;
  var v=document.createElement("video");
  v.className="pvid";
  v.muted=true; v.loop=true; v.playsInline=true;
  v.setAttribute("muted",""); v.setAttribute("playsinline",""); v.setAttribute("loop","");
  v.preload="auto";
  if(label) v.setAttribute("aria-label",label);
  if(REDUCE) v.controls=true;
  v.src=url;
  host.insertBefore(v,host.firstChild);
  if(VIO) VIO.observe(v); else if(!REDUCE){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
  return v;
}
var SEL = {};                       // toothNumber -> true
var state = { style:"honeycomb", metal:"gold" };
var TEETH = [];                     // {n,type,name,side,jaw,x,y,rot,w,d}
function projectRow(row,RX,RY,SPAN){
  var N=600, phis=[], cum=[0], i;
  for(i=0;i<=N;i++) phis.push(-SPAN/2+SPAN*i/N);
  for(i=1;i<=N;i++){
    var m=(phis[i-1]+phis[i])/2;
    cum[i]=cum[i-1]+Math.sqrt(RX*RX*Math.cos(m)*Math.cos(m)+RY*RY*Math.sin(m)*Math.sin(m))*(phis[i]-phis[i-1]);
  }
  var arcLen=cum[N];
  function phiAt(s){
    if(s<=0) return phis[0];
    if(s>=arcLen) return phis[N];
    for(var k=1;k<=N;k++) if(cum[k]>=s){
      var t=(s-cum[k-1])/(cum[k]-cum[k-1]);
      return phis[k-1]+(phis[k]-phis[k-1])*t;
    }
    return phis[N];
  }
  var total=0; for(i=0;i<row.length;i++) total+=row[i].w;
  var SCALE=arcLen/total, out=[], acc=0;
  for(i=0;i<row.length;i++){
    var x0=RX*Math.sin(phiAt(acc*SCALE));
    acc+=row[i].w;
    var x1=RX*Math.sin(phiAt(acc*SCALE));
    out.push({x0:x0,x1:x1,cx:(x0+x1)/2,pw:(x1-x0)});
  }
  return {t:out, scale:SCALE, half:RX*Math.sin(SPAN/2)};
}
var ARCH={};
function buildArchGeometry(){
  TEETH=[];
  var CX=310;
  var U=projectRow(U_ROW,236,170,152*Math.PI/180);
  var L=projectRow(L_ROW,212,152,150*Math.PI/180);
  ARCH={u:U,l:L,cx:CX};
  function upperEdge(u){ return 186-18*u*u; }
  function lowerEdge(v){ return 224+12*v*v; }
  function lay(row,proj,nums,jaw,edgeFn,dir){
    for(var i=0;i<row.length;i++){
      var R=row[i], P=proj.t[i];
      var cx=CX+P.cx, u=P.cx/proj.half;
      var edge=edgeFn(u);
      var h=R.h*proj.scale*(1-0.14*u*u);      // posterior crowns read shorter
      TEETH.push({
        n:nums[i], name:R.name, shape:R.shape, jaw:jaw,
        side:(i<5?"right":"left"),
        cx:cx, gy:edge-dir*h, h:h, w:Math.max(3,P.pw),
        flip:(dir<0),
        fore:Math.min(1,P.pw/(R.w*proj.scale))  // 1 head-on, →0 turned away
      });
    }
  }
  lay(U_ROW,U,UPPER_N,"upper",upperEdge, 1);
  lay(L_ROW,L,LOWER_N,"lower",lowerEdge,-1);
}
function toothPath(shape,w,h,flat){
  var hw=w/2, NW=flat?0.84:0.70, NC=flat?-0.01:-0.05;
  function P(fx,fy){ return (fx*hw).toFixed(2)+","+(fy*h).toFixed(2); }
  if(shape==="can"){        // single pointed cusp
    return "M"+P(-NW,0.04)
      +"C"+P(-0.88,0.07)+" "+P(-1.00,0.36)+" "+P(-0.97,0.62)
      +"Q"+P(-0.93,0.78)+" "+P(-0.50,0.88)
      +"Q"+P(-0.15,0.96)+" "+P(0,1.00)
      +"Q"+P(0.15,0.96)+" "+P(0.50,0.88)
      +"Q"+P(0.93,0.78)+" "+P(0.97,0.62)
      +"C"+P(1.00,0.36)+" "+P(0.88,0.07)+" "+P(NW,0.04)
      +"Q"+P(0,NC)+" "+P(-NW,0.04)+"Z";
  }
  if(shape==="pm"){         // broad rounded buccal cusp
    return "M"+P(-NW,0.05)
      +"C"+P(-0.90,0.09)+" "+P(-1.00,0.38)+" "+P(-0.98,0.62)
      +"Q"+P(-0.94,0.83)+" "+P(-0.42,0.94)
      +"Q"+P(-0.15,1.00)+" "+P(0,1.00)
      +"Q"+P(0.15,1.00)+" "+P(0.42,0.94)
      +"Q"+P(0.94,0.83)+" "+P(0.98,0.62)
      +"C"+P(1.00,0.38)+" "+P(0.90,0.09)+" "+P(NW,0.05)
      +"Q"+P(0,NC)+" "+P(-NW,0.05)+"Z";
  }
  return "M"+P(-NW,0.04)
    +"C"+P(-0.88,0.06)+" "+P(-1.00,0.34)+" "+P(-1.00,0.64)
    +"L"+P(-1.00,0.88)
    +"Q"+P(-1.00,1.00)+" "+P(-0.82,1.00)
    +"L"+P(0.82,1.00)
    +"Q"+P(1.00,1.00)+" "+P(1.00,0.88)
    +"L"+P(1.00,0.64)
    +"C"+P(1.00,0.34)+" "+P(0.88,0.06)+" "+P(NW,0.04)
    +"Q"+P(0,NC)+" "+P(-NW,0.04)+"Z";
}
function gumPath(list,dir,band){
  var i, d, a=list[0], z=list[list.length-1];
  var L=a.x0-18, R=z.x1+18, mid=list[Math.floor(list.length/2)];
  d="M"+L.toFixed(1)+","+(a.gy+dir*10).toFixed(1);
  for(i=0;i<list.length;i++){
    var it=list[i], nxt=list[i+1];
    var endX = nxt ? (it.x1+nxt.x0)/2 : R;
    var endY = nxt ? (dir>0 ? Math.max(it.gy,nxt.gy)+9 : Math.min(it.gy,nxt.gy)-9)
                   : it.gy+dir*10;
    d+="Q"+it.cx.toFixed(1)+","+(it.gy-dir*5).toFixed(1)+" "+endX.toFixed(1)+","+endY.toFixed(1);
  }
  d+="L"+R.toFixed(1)+","+(z.gy-dir*band).toFixed(1);
  d+="Q"+mid.cx.toFixed(1)+","+(mid.gy-dir*(band+10)).toFixed(1)+" "+L.toFixed(1)+","+(a.gy-dir*band).toFixed(1);
  return d+"Z";
}
function cavityPath(){
  var CX=ARCH.cx, XE=Math.max(ARCH.u.half,ARCH.l.half)+26, N=40, i, d="", t, x, mid, half;
  for(i=0;i<=N;i++){
    t=-1+2*i/N; x=CX+t*XE;
    mid=205-7*t*t; half=36*Math.sqrt(Math.max(0,1-t*t));
    d+=(i?"L":"M")+x.toFixed(1)+","+(mid-half).toFixed(1);
  }
  for(i=N;i>=0;i--){
    t=-1+2*i/N; x=CX+t*XE;
    mid=205-7*t*t; half=36*Math.sqrt(Math.max(0,1-t*t));
    d+="L"+x.toFixed(1)+","+(mid+half).toFixed(1);
  }
  return d+"Z";
}
function renderArch(){
  var svg=$("#arch"), i;
  if(!svg) return;
  svg.innerHTML = defsFor("a",["honeycomb","galaxy","mosaic","baguette"])
    + '<defs>'
    + '<radialGradient id="cav-a" cx="50%" cy="46%" r="62%">'
    +   '<stop offset="0%" stop-color="#000000"/><stop offset="100%" stop-color="#120C0C"/>'
    + '</radialGradient>'
    + '<linearGradient id="gum-u" x1="0" y1="0" x2="0" y2="1">'
    +   '<stop offset="0%" stop-color="#3E2528"/><stop offset="100%" stop-color="#7A4A4E"/>'
    + '</linearGradient>'
    + '<linearGradient id="gum-l" x1="0" y1="0" x2="0" y2="1">'
    +   '<stop offset="0%" stop-color="#7A4A4E"/><stop offset="100%" stop-color="#3E2528"/>'
    + '</linearGradient>'
    + '</defs>';
  svg.appendChild(el("path",{d:cavityPath(),fill:"url(#cav-a)"}));
  svg.appendChild(el("path",{d:cavityPath(),fill:"url(#cast-a)"}));
  var up=[],lo=[];
  for(i=0;i<TEETH.length;i++){
    var t=TEETH[i], e={x0:t.cx-t.w/2,x1:t.cx+t.w/2,cx:t.cx,gy:t.gy};
    (t.jaw==="upper"?up:lo).push(e);
  }
  svg.appendChild(el("path",{d:gumPath(up, 1, 26), fill:"url(#gum-u)"}));
  svg.appendChild(el("path",{d:gumPath(lo,-1,26), fill:"url(#gum-l)"}));
  svg.appendChild(el("text",{x:310,y:26,"text-anchor":"middle","class":"arch-label"},"Upper · teeth 4–13"));
  svg.appendChild(el("text",{x:310,y:352,"text-anchor":"middle","class":"arch-label"},"Lower · teeth 20–29"));
  for(i=0;i<TEETH.length;i++){
    (function(T){
      var g=el("g",{
        "class":"tooth","data-n":T.n,tabindex:"0",role:"checkbox","aria-checked":"false",
        "aria-label":"Tooth "+T.n+", "+T.jaw+" "+T.side+" "+T.name,
        transform:"translate("+T.cx.toFixed(1)+","+T.gy.toFixed(1)+")"+(T.flip?" scale(1,-1)":"")
      });
      var p=toothPath(T.shape,T.w,T.h);
      g.appendChild(el("path",{d:p,"class":"enamel",fill:"url(#enamel-a)",stroke:"#0A0908","stroke-width":"1.5","stroke-linejoin":"round"}));
      g.appendChild(el("ellipse",{
        cx:(-T.w*0.16).toFixed(1), cy:(T.h*0.30).toFixed(1),
        rx:Math.max(1,T.w*0.17).toFixed(1), ry:(T.h*0.24).toFixed(1),
        fill:"#FFFFFF", opacity:(0.17*T.fore).toFixed(2)
      }));
      var tint=(T.n*7)%5;
      g.appendChild(el("path",{d:p,fill:(tint<2?"#C9A24A":"#7C93A8"),opacity:(0.016+tint*0.011).toFixed(3)}));
      if(T.fore<0.95) g.appendChild(el("path",{d:p,fill:"#0A0908",opacity:((1-T.fore)*0.42).toFixed(2)}));
      var pc=toothPath(T.shape==="can"?"pm":T.shape,T.w*0.94,T.h*0.88,true);
      var cap=el("g",{"class":"tcap",transform:"translate(0,"+(T.h*0.085).toFixed(1)+")"});
      cap.appendChild(el("path",{d:pc,fill:"url(#m-a-"+state.metal+")","data-role":"plate"}));
      cap.appendChild(el("path",{d:pc,fill:"url(#p-a-"+state.style+")","data-role":"stones"}));
      cap.appendChild(el("g",{"data-role":"feat"},featureStones(state.style,T.shape==="can"?"pm":T.shape,T.w*0.94,T.h*0.88,T.n*37+5,"a",state.metal)));
      cap.appendChild(el("path",{d:pc,fill:"none",stroke:"#2A1E10","stroke-width":"2.6","stroke-opacity":".45","data-role":"rimin"}));
      cap.appendChild(el("path",{d:pc,fill:"none",stroke:"#F2F8FF","stroke-width":"2.4","stroke-linecap":"round",
        "stroke-dasharray":"0.1 3.4","data-role":"pave",opacity:(state.style==="baguette"?"1":"0")}));
      cap.appendChild(el("path",{d:pc,fill:"none",stroke:"#F7DF9A","stroke-width":"1.4","stroke-opacity":".95","data-role":"rim"}));
      if(T.fore<0.95) cap.appendChild(el("path",{d:pc,fill:"#0A0908",opacity:((1-T.fore)*0.38).toFixed(2)}));
      cap.appendChild(el("path",{d:pc,fill:"url(#sweep-a)","class":"sweep"}));
      var tr=rng(T.n*911+13), tk;
      for(tk=0;tk<6;tk++){
        var ta=tr(), tb=tr();
        var tx=(ta-0.5)*T.w*0.72, ty=T.h*(0.16+tb*0.68);
        var tc=el("circle",{cx:tx.toFixed(1),cy:ty.toFixed(1),r:(T.w*0.055).toFixed(1),
          fill:"#FFFFFF","class":"tw"});
        tc.style.animationDelay=(tr()*3.2).toFixed(2)+"s";
        cap.appendChild(tc);
      }
      g.appendChild(cap);
      g.addEventListener("click",function(){toggle(T.n);});
      g.addEventListener("keydown",function(e){ if(e.key===" "||e.key==="Enter"){e.preventDefault();toggle(T.n);} });
      g.addEventListener("mouseenter",function(){
        var hn=$("#hoverName"); if(hn) hn.innerHTML="#"+T.n+" &middot; "+T.jaw+" "+T.side+" "+T.name;
      });
      g.addEventListener("mouseleave",function(){ var h=$("#hoverName"); if(h) h.innerHTML="&mdash;"; });
      svg.appendChild(g);
    })(TEETH[i]);
  }
  paintArch();
}
function paintArch(){
  var archEl=$("#arch"); if(!archEl) return;
  var nodes=archEl.querySelectorAll(".tooth");
  for(var i=0;i<nodes.length;i++){
    var n=nodes[i].getAttribute("data-n");
    var on=!!SEL[n];
    nodes[i].classList.toggle("on",on);
    nodes[i].setAttribute("aria-checked",on?"true":"false");
    nodes[i].querySelector('[data-role="plate"]').setAttribute("fill","url(#m-a-"+state.metal+")");
    nodes[i].querySelector('[data-role="stones"]').setAttribute("fill","url(#p-a-"+state.style+")");
    var M=metal(state.metal);
    nodes[i].querySelector('[data-role="rim"]').setAttribute("stroke",M.c[0]);
    var T=TEETH[i], fg=nodes[i].querySelector('[data-role="feat"]');
    if(fg) fg.innerHTML=featureStones(state.style,T.shape==="can"?"pm":T.shape,T.w*0.94,T.h*0.88,T.n*37+5,"a",state.metal);
    var pv=nodes[i].querySelector('[data-role="pave"]');
    if(pv) pv.setAttribute("opacity",state.style==="baguette"?"1":"0");
  }
}
function toggle(n){ if(SEL[n]) delete SEL[n]; else SEL[n]=true; paintArch(); updateQuote(); markPreset(); }
function count(){ return Object.keys(SEL).length; }
function jawSummary(){
  var up=0,lo=0;
  for(var k in SEL){ if(UPPER_N.indexOf(+k)>=0) up++; else lo++; }
  if(up&&lo) return up+" upper / "+lo+" lower";
  if(up) return up+" upper";
  if(lo) return lo+" lower";
  return "—";
}
function selectedList(){
  var out=[];
  for(var i=0;i<TEETH.length;i++){
    var T=TEETH[i];
    if(SEL[T.n]) out.push("#"+T.n+" "+T.jaw+" "+T.side+" "+T.name);
  }
  return out;
}
var PRESETS=[
  {g:"Upper", k:"top6",  label:"Top 6",   set:[6,7,8,9,10,11]},
  {g:"Upper", k:"top8",  label:"Top 8",   set:[5,6,7,8,9,10,11,12]},
  {g:"Upper", k:"top10", label:"Top 10",  set:[4,5,6,7,8,9,10,11,12,13]},
  {g:"Lower", k:"bot6",  label:"Bottom 6",  set:[22,23,24,25,26,27]},
  {g:"Lower", k:"bot8",  label:"Bottom 8",  set:[21,22,23,24,25,26,27,28]},
  {g:"Lower", k:"bot10", label:"Bottom 10", set:[20,21,22,23,24,25,26,27,28,29]},
  {g:"Sets",  k:"one",   label:"1 Tooth", set:[8],  hint:"one upper central — tap any other tooth to move it"},
  {g:"Sets",  k:"fangz", label:"Fangz",   set:[6,11,22,27], hint:"all four canines, top and bottom"},
  {g:"Sets",  k:"both6", label:"Top + bottom 6", set:[6,7,8,9,10,11,22,23,24,25,26,27]},
  {g:"Sets",  k:"both8", label:"Top + bottom 8", set:[5,6,7,8,9,10,11,12,21,22,23,24,25,26,27,28]},
  {g:"Sets",  k:"full",  label:"Full 20", set:UPPER_N.concat(LOWER_N)},
  {g:"Sets",  k:"clear", label:"Clear",   set:[]}
];
function renderPresets(){
  var w=$("#presets"); if(!w) return; w.innerHTML="";
  var groups=["Upper","Lower","Sets"];
  groups.forEach(function(gname){
    var row=document.createElement("div");
    row.className="pgroup";
    row.innerHTML='<span class="pglabel">'+(gname==="Sets"?"Sets":gname)+'</span>';
    PRESETS.filter(function(P){return P.g===gname;}).forEach(function(P){
      var b=document.createElement("button");
      b.className="chip"; b.type="button"; b.textContent=P.label; b.setAttribute("data-k",P.k);
      if(P.hint) b.title=P.hint;
      b.addEventListener("click",function(){
        SEL={}; P.set.forEach(function(n){SEL[n]=true;});
        paintArch(); updateQuote(); markPreset();
      });
      row.appendChild(b);
    });
    w.appendChild(row);
  });
}
function markPreset(){
  var cur=Object.keys(SEL).map(Number).sort(function(a,b){return a-b;}).join(",");
  var pw=$("#presets"); if(!pw) return;
  var chips=pw.querySelectorAll(".chip"), i;
  for(i=0;i<chips.length;i++){
    var k=chips[i].getAttribute("data-k"), P=null, j;
    for(j=0;j<PRESETS.length;j++) if(PRESETS[j].k===k){P=PRESETS[j];break;}
    if(!P){ chips[i].classList.remove("act"); continue; }
    var sig=P.set.slice().sort(function(a,b){return a-b;}).join(",");
    chips[i].classList.toggle("act", sig===cur && P.k!=="clear");
  }
}
function renderPickers(){
  var so=$("#styleOpts"); if(!so) return; so.innerHTML="";
  SETTINGS.forEach(function(S){
    var b=document.createElement("button");
    b.type="button"; b.className="opt"+(S.id===state.style?" act":"");
    b.setAttribute("data-id",S.id);
    b.innerHTML='<span class="sw"><svg viewBox="0 0 34 34">'+defsFor("sw"+S.id,[S.id])
      +'<rect width="34" height="34" fill="url(#m-sw'+S.id+'-gold)"/>'
      +'<rect width="34" height="34" fill="url(#p-sw'+S.id+'-'+S.id+')"/></svg></span>'
      +'<span class="ot"><b>'+S.name+'</b><span>'+S.why+'</span></span>'
      +'<span class="op mono">'+money(S.tiers[6])+' / 6</span>';
    b.addEventListener("click",function(){
      state.style=S.id;
      var all=so.querySelectorAll(".opt");
      for(var i=0;i<all.length;i++) all[i].classList.toggle("act",all[i].getAttribute("data-id")===S.id);
      paintArch(); updateQuote();
    });
    so.appendChild(b);
  });
  var mo=$("#metalOpts"); if(!mo) return; mo.innerHTML="";
  METALS.forEach(function(M){
    var b=document.createElement("button");
    b.type="button"; b.className="metal"+(M.id===state.metal?" act":"");
    b.setAttribute("data-id",M.id);
    b.innerHTML='<i style="background:linear-gradient(160deg,'+M.c[0]+','+M.c[1]+' 52%,'+M.c[2]+')"></i><span>'+M.name+'</span>';
    b.addEventListener("click",function(){
      state.metal=M.id;
      var all=mo.querySelectorAll(".metal");
      for(var i=0;i<all.length;i++) all[i].classList.toggle("act",all[i].getAttribute("data-id")===M.id);
      paintArch(); updateQuote();
    });
    mo.appendChild(b);
  });
}
function currentQuote(){
  var S=setting(state.style), n=count();
  return { style:S, metal:metal(state.metal), n:n, price:priceFor(S.tiers,n) };
}
function updateQuote(){
  if(!$("#qStyle")) return;
  var q=currentQuote();
  $("#qStyle").textContent=q.style.name;
  $("#qMetal").textContent=q.metal.name;
  $("#qCount").textContent=String(q.n);
  $("#qArch").textContent=jawSummary();
  $("#qPrice").textContent=q.n?money(q.price):"$0";
  var rc=document.getElementById("rCount"), rp=document.getElementById("rPrice");
  if(rc){ rc.textContent=String(q.n); rp.textContent=q.n?money(q.price):"$0"; }
  $("#reserveBtn").disabled=!q.n;
  var note;
  if(!q.n){ note="Select at least one tooth to see a price. Every finish is the same price — gold, white gold and rose all run the same."; }
  else if(q.style.tiers[q.n]!=null){ note="Priced at the "+q.n+"-tooth tier. Includes the impression kit, prepaid return mailer and US shipping."; }
  else { note="Priced between the tiers either side of "+q.n+" teeth. Includes the impression kit, prepaid return mailer and US shipping."; }
  $("#qNote").textContent=note;
}
function renderSettingCards(){
  var wrap=$("#settingCards"); if(!wrap) return; wrap.innerHTML="";
  SETTINGS.forEach(function(S){
    var c=document.createElement("article");
    c.className="card";
    c.innerHTML=
      '<div class="card-art">'
        +'<span class="card-tag">'+S.name+'</span></div>'
      +'<div class="card-b">'
        +'<h3>'+S.full+'</h3>'
        +'<p>'+S.blurb+'</p>'
        +'<ul>'+S.feats.map(function(f){return "<li>"+f+"</li>";}).join("")+'</ul>'
        +'<div class="card-foot">'
          +'<span><span class="from">Six teeth</span><br><span class="amt">'+money(S.tiers[6])+'</span></span>'
          +'<button class="go" type="button" data-id="'+S.id+'">Build this &rarr;</button>'
        +'</div>'
      +'</div>';
    c.querySelector(".go").addEventListener("click",function(){
      state.style=S.id;
      if(!count()) PRESETS[0].set.forEach(function(n){SEL[n]=true;});
      renderPickers(); paintArch(); updateQuote(); markPreset();
      document.getElementById("build").scrollIntoView({behavior:"smooth"});
    });
    wrap.appendChild(c);
    mountVideo(c.querySelector(".card-art"),S.id,S.full+" grillz");
  });
}
function renderFaq(){
  var w=$("#faqList"); if(!w) return; w.innerHTML="";
  FAQ.forEach(function(f,i){
    var d=document.createElement("details");
    if(i===0) d.open=true;
    d.innerHTML='<summary><span class="q mono">'+String(i+1).padStart(2,"0")+'</span><span>'+f[0]+'</span><span class="pm">+</span></summary>'
      +'<div class="ans">'+f[1]+'</div>';
    w.appendChild(d);
  });
}
function sparkle(){
  var c=$("#spark"), ctx=c.getContext("2d"), parts=[], W=0,H=0, raf=null;
  var reduce=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var HUES=["#3FD8EE","#8B7CF6","#FFB13D","#E6F0FB","#F7DF9A"];
  function size(){
    var r=c.getBoundingClientRect(), dpr=Math.min(window.devicePixelRatio||1,2);
    W=r.width; H=r.height;
    c.width=Math.max(1,W*dpr); c.height=Math.max(1,H*dpr);
    ctx.setTransform(dpr,0,0,dpr,0,0);
  }
  function seed(){
    parts=[];
    var n=Math.min(70,Math.round(W*H/16000));
    for(var i=0;i<n;i++) parts.push({
      x:Math.random()*W, y:Math.random()*H,
      r:0.6+Math.random()*2.1,
      c:HUES[Math.floor(Math.random()*HUES.length)],
      ph:Math.random()*Math.PI*2,
      sp:0.25+Math.random()*0.7,
      dy:-(0.05+Math.random()*0.14)
    });
  }
  function draw(t){
    ctx.clearRect(0,0,W,H);
    for(var i=0;i<parts.length;i++){
      var p=parts[i];
      var a=reduce?0.5:(0.22+0.78*Math.pow(Math.abs(Math.sin(t*0.001*p.sp+p.ph)),3));
      ctx.globalAlpha=a*0.85;
      ctx.fillStyle=p.c;
      ctx.beginPath(); ctx.arc(p.x,p.y,p.r,0,Math.PI*2); ctx.fill();
      if(p.r>1.5&&a>0.6){
        ctx.globalAlpha=a*0.34; ctx.strokeStyle=p.c; ctx.lineWidth=0.7;
        ctx.beginPath();
        ctx.moveTo(p.x-p.r*3.6,p.y); ctx.lineTo(p.x+p.r*3.6,p.y);
        ctx.moveTo(p.x,p.y-p.r*3.6); ctx.lineTo(p.x,p.y+p.r*3.6);
        ctx.stroke();
      }
      if(!reduce){ p.y+=p.dy; if(p.y<-4){p.y=H+4;p.x=Math.random()*W;} }
    }
    ctx.globalAlpha=1;
    if(!reduce) raf=requestAnimationFrame(draw);
  }
  function boot(){ size(); seed(); if(raf) cancelAnimationFrame(raf); if(reduce) draw(0); else raf=requestAnimationFrame(draw); }
  boot();
  var to; window.addEventListener("resize",function(){clearTimeout(to);to=setTimeout(boot,180);});
}
var TERMS=[
  "Payment is taken by Shopify’s secure checkout on the next screen. Flex Factory never sees or stores your card details.",
  "The price covers your impression kit, the prepaid return mailer, fabrication and shipping back to you inside the US.",
  "Build time is 6 to 8 weeks from the day your impression reaches us, not from the day you order.",
  "You see photographs of the finished set before it leaves the bench. If something is off, it goes back.",
  "If the fit is wrong on arrival we re-cut it at no charge. If your impression comes out unusable we send a fresh kit at no charge.",
  "Every set is cut to your own impression and is made for you alone. It is a final sale: it cannot be returned, exchanged or refunded for a change of mind. What stays covered is our own work — if the fit is wrong or the set is faulty, we re-cut or repair it at no charge."
];
function specPairsFor(q){
  if(q && q.style && q.style.dial){   // watch: style model, one cut, plain crown
    var out=[["Style",q.style.full],["Dial",q.style.dial],
             ["Stone",q.stone.full],["Metal tone",q.tone.name]];
    out.push(["Crown","Plain metal, no cabochon"]);
    out.push(["Movement","Automatic, sapphire crystal"]);
    out.push(["Build time","1 week on the bench, then shipping"]);
    return out;
  }
  return [["Setting",q.style.full],["Finish",q.metal.name],
          ["Teeth",q.n+" ("+jawSummary()+")"],
          ["Tooth positions",selectedList().join("; ")||"—"],
          ["Build time","6–8 weeks from the day the impression arrives"]];
}
function specTextFor(q,extra,sig){
  return specText(q,extra,sig);
}
function specText(q,extra,sig){
  var lines=[
    "FLEX FACTORY — CUSTOM GRILLZ ORDER","",
    "Setting:   "+q.style.full,
    "Finish:    "+q.metal.name,
    "Teeth:     "+q.n+" ("+jawSummary()+")",
    "Positions: "+(selectedList().join("; ")||"none"),
    "",
    "Total:     "+money(q.price)+" USD",
    "Includes:  impression kit, prepaid return mailer, fabrication, US shipping",
    "Build:     6-8 weeks from the day the impression reaches us"
  ];
  if(extra) lines=lines.concat(["","CUSTOMER","Name:  "+extra.name,"Email: "+extra.email,"Phone: "+(extra.phone||"—"),"Notes: "+(extra.notes||"—")]);
  if(sig) lines=lines.concat(["","AGREEMENT ACCEPTED AND SIGNED",
    "Signed by: "+sig.name,
    "Signed at: "+sig.when,
    "Signature: captured on device ("+sig.px+" px, "+sig.kb+" KB PNG)",
    "","Terms accepted:"].concat(TERMS.map(function(t,i){return "  "+(i+1)+". "+t;})));
  return lines.join("\n");
}
var SIG_ALPHA="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
function sigEnc12(v){
  v=Math.max(0,Math.min(4095,Math.round(v)));
  return SIG_ALPHA.charAt((v>>6)&63)+SIG_ALPHA.charAt(v&63);
}
function sigSimplify(pts,tol){
  if(pts.length<3) return pts.slice();
  var out=[pts[0]], i, prev=pts[0];
  for(i=1;i<pts.length-1;i++){
    var dx=pts[i][0]-prev[0], dy=pts[i][1]-prev[1];
    if(dx*dx+dy*dy >= tol*tol){ out.push(pts[i]); prev=pts[i]; }
  }
  out.push(pts[pts.length-1]);
  return out;
}
function sigEncode(strokes,w,h,budget){
  var tol=1.2, enc="", tries=0, total=0;
  do{
    total=0; var parts=[];
    for(var k=0;k<strokes.length;k++){
      var sp=sigSimplify(strokes[k],tol);
      total+=sp.length;
      var str="";
      for(var i=0;i<sp.length;i++)
        str += sigEnc12(sp[i][0]/w*4095) + sigEnc12(sp[i][1]/h*4095);
      parts.push(str);
    }
    enc=parts.join(".");
    if(total<=budget) break;
    tol*=1.6; tries++;
  } while(tries<9);
  return Math.round(w)+"x"+Math.round(h)+"|"+enc;
}
function makeSigPad(canvas,onChange){
  var ctx=canvas.getContext("2d"), drawing=false, dirty=false, last=null, dpr=Math.min(window.devicePixelRatio||1,2);
  var strokes=[], cur=null, box={w:1,h:1};
  function fit(){
    var r=canvas.getBoundingClientRect();
    canvas.width=Math.max(1,Math.round(r.width*dpr));
    canvas.height=Math.max(1,Math.round(r.height*dpr));
    ctx.setTransform(dpr,0,0,dpr,0,0);
    ctx.lineWidth=2.3; ctx.lineCap="round"; ctx.lineJoin="round"; ctx.strokeStyle="#EDF2F7";
    box.w=r.width||1; box.h=r.height||1;
  }
  function at(e){ var r=canvas.getBoundingClientRect(); return [e.clientX-r.left, e.clientY-r.top]; }
  function down(e){
    e.preventDefault(); drawing=true; last=at(e);
    cur=[last.slice()]; strokes.push(cur);
    if(canvas.setPointerCapture&&e.pointerId!=null) try{canvas.setPointerCapture(e.pointerId);}catch(err){}
  }
  function move(e){
    if(!drawing) return;
    e.preventDefault();
    var p=at(e);
    ctx.beginPath(); ctx.moveTo(last[0],last[1]); ctx.lineTo(p[0],p[1]); ctx.stroke();
    if(cur) cur.push(p.slice());
    last=p;
    if(!dirty){ dirty=true; canvas.classList.add("signed"); }
    if(onChange) onChange();
  }
  function up(){ drawing=false; cur=null; }
  canvas.addEventListener("pointerdown",down);
  canvas.addEventListener("pointermove",move);
  window.addEventListener("pointerup",up);
  canvas.addEventListener("pointerleave",up);
  fit();
  return {
    empty:function(){
      if(!dirty) return true;
      var pts=0, minX=1e9, maxX=-1e9, minY=1e9, maxY=-1e9;
      for(var i=0;i<strokes.length;i++){
        for(var j=0;j<strokes[i].length;j++){
          var p=strokes[i][j]; pts++;
          if(p[0]<minX)minX=p[0]; if(p[0]>maxX)maxX=p[0];
          if(p[1]<minY)minY=p[1]; if(p[1]>maxY)maxY=p[1];
        }
      }
      if(pts < 8) return true;
      return (maxX-minX) < 40 && (maxY-minY) < 20;
    },
    clear:function(){ ctx.clearRect(0,0,canvas.width,canvas.height); dirty=false; strokes=[]; cur=null; canvas.classList.remove("signed"); if(onChange) onChange(); },
    data:function(){ return dirty?canvas.toDataURL("image/png"):""; },
    size:function(){ return canvas.width+"x"+canvas.height; },
    path:function(){ return dirty?sigEncode(strokes,box.w,box.h,180):""; },
    points:function(){ var n=0,i; for(i=0;i<strokes.length;i++) n+=strokes[i].length; return n; }
  };
}
function checkoutURL(q,extra,sig){
  var v = VARIANTS[q.style.id] && VARIANTS[q.style.id][q.n];
  if(!v) return "";
  var a=[];
  function add(k,val){ if(val) a.push("attributes["+encodeURIComponent(k)+"]="+encodeURIComponent(val)); }
  add("Setting", q.style.full);
  add("Finish", q.metal.name);
  add("Teeth", q.n+" ("+jawSummary()+")");
  add("Tooth positions", selectedList().join("; "));
  add("Build time", "6-8 weeks from the day the impression arrives");
  if(sig){
    add("Signed by", sig.name);
    add("Signed at", sig.when);
    add("Terms", "Accepted at checkout — v"+sig.termsVersion+" ("+sig.termsHash+")");
    add("Signature", sig.path);
  }
  add("Email updates", (extra && extra.notifyEmail) ? "Yes" : "No");
  add("Text updates",  (extra && extra.notifySms)   ? "Yes" : "No");
  if(extra && extra.phone) add("Phone", extra.phone);
  if(extra && extra.notes) add("Customer notes", extra.notes);
  var qs = a.join("&");
  if(extra && extra.email) qs += "&checkout[email]="+encodeURIComponent(extra.email);
  return SHOP_BASE+"/cart/"+v+":1?"+qs;
}
var TERMS_VERSION = "2026-09-20";
function termsHash(list){
  var t=list.join("\n"), h=5381, i;
  for(i=0;i<t.length;i++) h=((h*33)^t.charCodeAt(i))>>>0;
  return h.toString(36);
}
function b64url(str){
  var b = btoa(unescape(encodeURIComponent(str)));
  return b.replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,"");
}
function agreementLink(q,extra,sig,specPairs,total,terms){
  try{
    var payload = {
      name: (extra&&extra.name)||"", email:(extra&&extra.email)||"",
      phone:(extra&&extra.phone)||"", notes:(extra&&extra.notes)||"",
      spec: specPairs, total: total, terms: terms,
      termsRef: sig ? ("Version "+sig.termsVersion+" · fingerprint "+sig.termsHash) : "",
      sig: sig ? sig.path : "", when: sig ? sig.when : ""
    };
    return SHOP_BASE + "/pages/agreement?d=" + b64url(JSON.stringify(payload));
  }catch(e){ return ""; }
}
function openOrder(cfg){
  cfg = cfg || {};
  var SPEC    = cfg.spec  || specText,
      URLF    = cfg.url   || checkoutURL,
      TERMSET = cfg.terms || TERMS,
      KIND    = cfg.kind  || "grillz";
  var q = cfg.quote || currentQuote(), sig=null, agreed=false;
  var scrim=document.createElement("div");
  scrim.className="scrim";
  scrim.innerHTML=
    '<div class="modal" style="position:relative">'
    +'<button class="mclose" aria-label="Close">&times;</button>'
    +'<h3 id="ordTitle">Your order</h3>'
    +'<div class="steps-dots"><span class="dot-s on" id="d1"></span><span class="dot-s" id="d2"></span></div>'
    +'<div class="step-label" id="ordStep">Step 1 of 2 &middot; Your details</div>'
    +'<div id="step1">'
      +'<div class="spec">'+esc(SPEC(q))+'</div>'
      +'<div class="frow"><label for="oName">Full name</label><input id="oName" required autocomplete="name"></div>'
      +'<div class="frow"><label for="oEmail">Email</label><input id="oEmail" type="email" required autocomplete="email"></div>'
      +'<div class="frow"><label for="oPhone">Phone (optional)</label><input id="oPhone" autocomplete="tel"></div>'
      +'<div class="frow"><label for="oNotes">Anything we should know?</label>'
        +'<textarea id="oNotes" placeholder="'+esc(cfg.notes||"Deadline, gaps or missing teeth, previous grillz that didn’t fit…")+'"></textarea></div>'
      +'<button class="btn btn-gold btn-lg" type="button" id="toStep2" style="width:100%;margin-top:20px">Continue to sign</button>'
    +'</div>'
    +'<div id="step2" hidden>'
      +'<p style="color:var(--muted);font-size:13.5px;margin-top:10px">Read these, then sign. Signing takes you to Shopify&rsquo;s secure checkout with your build already in the cart.</p>'
      +'<ul class="terms">'+TERMSET.map(function(t){return "<li>"+esc(t)+"</li>";}).join("")+'</ul>'
      +'<label class="agree"><input type="checkbox" id="oAgree"><span>I have read the terms above and I am placing this order.</span></label>'
      +'<label class="agree"><input type="checkbox" id="oNotifyEmail"><span>Email me at each stage of my build.</span></label>'
      +'<label class="agree"><input type="checkbox" id="oNotifySms"><span>Text me at each stage. Message rates apply — reply STOP any time.</span></label>'
      +'<div class="sigwrap">'
        +'<div class="sighead"><span class="step-label" style="margin:0">Sign here</span>'
          +'<button type="button" id="sigClear">Clear</button></div>'
        +'<canvas id="sigPad" aria-label="Signature pad"></canvas>'
        +'<p class="note" style="margin:6px 0 0;font-size:12px">Sign your full name across the box — a dot or initial will not record.</p>'
        +'<div class="sigline"><span id="sigName">&mdash;</span><span id="sigDate">&mdash;</span></div>'
      +'</div>'
      +'<a class="btn btn-gold btn-lg" id="ordSend" role="button" aria-disabled="true" style="width:100%;margin-top:20px;pointer-events:none;opacity:.45">Continue to secure checkout</a>'
      +'<div id="payBox" hidden>'
        +'<p class="note" style="margin-top:12px">Takes you to Flex Factory&rsquo;s secure checkout with your build already in the cart. If the button doesn&rsquo;t move, copy the link and open it yourself.</p>'
        +'<div class="linkrow"><input id="payLink" readonly aria-label="Checkout link"><button type="button" id="copyLink" class="chip">Copy</button></div>'
      +'</div>'
      +'<button class="btn btn-ghost" type="button" id="ordBack" style="width:100%;margin-top:8px">Back</button>'
      +'<button class="btn btn-ghost" type="button" id="copySpec" style="width:100%;margin-top:8px">Copy the order spec</button>'
    +'</div>'
    +'</div>';
  document.body.appendChild(scrim);
  var pad=null;
  function close(){ scrim.remove(); document.removeEventListener("keydown",onKey); }
  function onKey(e){ if(e.key==="Escape") close(); }
  scrim.querySelector(".mclose").addEventListener("click",close);
  scrim.addEventListener("click",function(e){ if(e.target===scrim) close(); });
  document.addEventListener("keydown",onKey);
  function details(){
    return {
      name:$("#oName",scrim).value.trim(),
      email:$("#oEmail",scrim).value.trim(),
      phone:$("#oPhone",scrim).value.trim(),
      notes:$("#oNotes",scrim).value.trim(),
      notifyEmail: !!(($("#oNotifyEmail",scrim)||{}).checked),
      notifySms:   !!(($("#oNotifySms",scrim)||{}).checked)
    };
  }
  function refreshSend(){
    var ok = agreed && pad && !pad.empty();
    var a=$("#ordSend",scrim);
    if(ok){
      var u=URLF(q,details(),signature());
      if(u){
        a.href=u; a.setAttribute("aria-disabled","false");
        a.style.pointerEvents=""; a.style.opacity="";
        $("#payLink",scrim).value=u;
        $("#payBox",scrim).hidden=false;
        return;
      }
    }
    a.removeAttribute("href");
    a.setAttribute("aria-disabled","true");
    a.style.pointerEvents="none"; a.style.opacity=".45";
    $("#payBox",scrim).hidden=true;
  }
  $("#toStep2",scrim).addEventListener("click",function(){
    var d=details();
    if(!d.name){ $("#oName",scrim).focus(); toast(KIND==="watch" ? "Add your name for the order" : "Add your name so we know whose mold it is"); return; }
    if(!d.email || d.email.indexOf("@")<0){ $("#oEmail",scrim).focus(); toast("Add an email we can confirm on"); return; }
    $("#step1",scrim).hidden=true;
    $("#step2",scrim).hidden=false;
    $("#ordTitle",scrim).textContent="Terms and signature";
    $("#ordStep",scrim).innerHTML="Step 2 of 2 &middot; Terms and signature";
    $("#d2",scrim).classList.add("on");
    $("#sigName",scrim).textContent=d.name;
    $("#sigDate",scrim).textContent=new Date().toLocaleString();
    scrim.querySelector(".modal").scrollTop=0;
    if(!pad) pad=makeSigPad($("#sigPad",scrim),refreshSend);
  });
  $("#ordBack",scrim).addEventListener("click",function(){
    $("#step2",scrim).hidden=true;
    $("#step1",scrim).hidden=false;
    $("#ordTitle",scrim).textContent="Your order";
    $("#ordStep",scrim).innerHTML="Step 1 of 2 &middot; Your details";
    $("#d2",scrim).classList.remove("on");
  });
  $("#oAgree",scrim).addEventListener("change",function(){ agreed=this.checked; refreshSend(); });
  $("#sigClear",scrim).addEventListener("click",function(){ if(pad) pad.clear(); });
  $("#copySpec",scrim).addEventListener("click",function(){
    copy(SPEC(q,details(),signature()));
    toast("Order copied to your clipboard");
  });
  function signature(){
    if(!pad || pad.empty()) return null;
    var url=pad.data(), now=new Date();
    var accepted = (typeof TERMSET!=="undefined") ? TERMSET : TERMS;
    return {
      name:details().name,
      when:now.toLocaleString(),
      whenISO:now.toISOString(),
      px:pad.size(),
      kb:Math.round(url.length*0.75/1024),
      url:url,
      path:pad.path(),
      points:pad.points(),
      termsVersion:TERMS_VERSION,
      termsHash:termsHash(accepted)
    };
  }
  $("#ordSend",scrim).addEventListener("click",function(){
    var d=details(), sg=signature();
    if(!sg) return;
    sendSignedRecord(q,d,sg,this.href,(typeof TERMSET!=="undefined")?TERMSET:TERMS);
  });
  $("#copyLink",scrim).addEventListener("click",function(e){
    e.preventDefault();
    var f=$("#payLink",scrim);
    if(f.value){ f.select(); copy(f.value); toast("Checkout link copied"); }
  });
  $("#payLink",scrim).addEventListener("focus",function(){ this.select(); });
}
function sendSignedRecord(q,d,sg,checkoutHref,termsList){
  var pairs = (typeof specPairsFor==="function") ? specPairsFor(q) : [];
  var total = money(q.price);
  var terms = termsList || TERMS;
  var link  = agreementLink(q,d,sg,pairs,total,terms);
  if(!FORM_ENDPOINT) return link;
  var body = {
    subject: "Signed order — " + (d.name||"new customer") + " — " + total,
    name: d.name, email: d.email, phone: d.phone || "", notes: d.notes || "",
    total: total, signed_at: sg.when, terms_version: sg.termsVersion,
    terms_fingerprint: sg.termsHash, agreement_link: link,
    signature_data: sg.path, checkout_link: checkoutHref || "",
    message: (typeof specTextFor==="function" ? specTextFor(q,d,sg) : "")
             + "\n\nOpen the signed agreement:\n" + link
  };
  if(FORM_ACCESS_KEY) body.access_key = FORM_ACCESS_KEY;
  try{
    fetch(FORM_ENDPOINT,{method:"POST",keepalive:true,
      headers:{"Content-Type":"application/json",Accept:"application/json"},
      body:JSON.stringify(body)}).catch(function(){});
  }catch(e){}
  return link;
}
function mailFallback(body,extra){
  var url="mailto:"+ORDER_EMAIL
    +"?subject="+encodeURIComponent("Signed grillz order — "+(extra.name||"new customer"))
    +"&body="+encodeURIComponent(body);
  window.location.href=url;
}
function copy(t){
  if(navigator.clipboard&&navigator.clipboard.writeText) navigator.clipboard.writeText(t);
  else { var ta=document.createElement("textarea"); ta.value=t; document.body.appendChild(ta); ta.select(); try{document.execCommand("copy");}catch(e){} ta.remove(); }
}
function toast(msg){
  var t=document.createElement("div"); t.className="toast"; t.textContent=msg;
  document.body.appendChild(t);
  setTimeout(function(){ t.style.transition="opacity .4s"; t.style.opacity="0"; setTimeout(function(){t.remove();},420); },2600);
}
var KB = [
  {k:["price","cost","how much","expensive","pricing","quote","$"],
   a:"Pricing runs off two things: which setting, and how many teeth.\n\n<b>Six teeth</b> — Honeycomb $650, Mosaic $675, Galaxy $700, Baguette $805.\n<b>Eight teeth</b> — $850 / $875 / $900 / $1,035.\n<b>Two teeth</b> start at $275 in the 3D studio; a single cap is a custom order from $150.\n<b>Full 20</b> runs $1,600 to $1,955.\n\nEvery price includes the impression kit, the prepaid return mailer, fabrication and US shipping. Metal finish doesn't change the price. Pick a tooth count in the 3D studio and the price moves live.\n\n<b>Watches</b> are $750 in moissanite or $3,500 in lab-grown diamond, any dial. <b>G-Shock and Apple Watch covers</b> run $259 to $495."},
  {k:["mold","impression","kit","putty","tray","how do i take"],
   a:"The kit does what a dentist chair does. Inside: two trays sized to your arch, silicone putty in base and catalyst, a mixing card, instructions and a prepaid return mailer with the label already on it.\n\nYou knead the two putties about thirty seconds until the color is even, load the tray, seat it over your teeth and hold still for three minutes, then pull straight down. You want crisp tooth edges — if it smears, there's spare putty for a second go. Whole thing takes about ten minutes."},
  {k:["how long","turnaround","time","when will","wait","weeks","fast","rush","deadline"],
   a:"Grillz: six to eight weeks on the bench from the day your impression reaches us, plus the mail:\n\n• Kit ships within one business day of your order\n• 5–8 business days each way in the mail\n• 6–8 weeks on the bench once your impression lands\n• 5–8 business days tracked shipping back to you\n\nWatches take about a week on the bench, then shipping. G-Shock and Apple Watch covers are 6–8 weeks from the day you order.\n\nIf you're working to a date — a shoot, a wedding, a birthday — tell me the date and Flex Factory will tell you straight whether it's doable rather than promising and missing."},
  {k:["moissanite","diamond","real","stone","fake","cz","cubic"],
   a:"Moissanite, and we say so plainly — it isn't diamond and we won't pretend otherwise.\n\nIt's silicon carbide, 9.25 on the Mohs hardness scale against diamond's 10, so it holds up fine to daily wear. Here's the part people don't expect: its dispersion is 0.104 against diamond's 0.044, which means it throws <b>more</b> colored fire than diamond does. That rainbow flash is the whole reason we use it — at a fraction of diamond's price.\n\nThe one exception is the iced watch, which you can also order in lab-grown diamond. It is sold as lab-grown, never as mined, and the order says which stone you chose."},
  {k:["setting","honeycomb","galaxy","mosaic","baguette","difference","which style","pattern"],
   a:"Same stones, same metal — what changes is the geometry.\n\n<b>Honeycomb</b> — a hexagonal lattice locked edge to edge, almost no metal showing. The cleanest and most uniform.\n<b>Galaxy</b> — many stone sizes packed tight with several larger stones dropped at random. The loudest, and no two teeth match.\n<b>Mosaic</b> — fine pavé built around one big centre stone with a hand-set halo on every tooth. The most jewellery-like.\n<b>Baguette</b> — rectangular step cuts channel-set in rows with a micro-pavé border. Straight lines and long flashes instead of pinpoint sparkle.\n\nOne word each: Honeycomb is precise, Galaxy is wild, Mosaic is refined, Baguette is architectural."},
  {k:["how many teeth","which teeth","top 6","start","first","beginner","recommend","should i","one tooth","single"],
   a:"Most first orders are the <b>top six</b> — two centrals, two laterals, two canines. Those are the teeth that actually show when you talk and smile, so you get the whole effect without paying for teeth nobody sees.\n\nAfter that the common steps up are top eight, then top and bottom six. The 3D studio starts at two teeth from $275; a single canine or central is a custom order from $150."},
  {k:["fit","doesn't fit","wrong","loose","tight","uncomfortable","refit"],
   a:"If the fit is wrong on arrival we re-cut it at no charge — that's the whole trade you get for taking an impression instead of buying a pre-formed tray. And if the impression itself came out unusable, we mail you a fresh kit rather than guessing at your arch."},
  {k:["clean","care","maintenance","tarnish","wash"],
   a:"Warm water, a soft toothbrush and a drop of unscented dish soap. Brush the inside as well as the face, rinse, dry them fully before they go back in the case.\n\nAvoid all four of these — they can loosen stone settings: boiling water, bleach, ultrasonic cleaners, alcohol."},
  {k:["eat","drink","sleep","wear","food","all day"],
   a:"Water's fine. Eating isn't — take them out for meals and for sleeping. Food packs under the plate and sits against your gums, and that's what causes irritation. It's the food, not the metal."},
  {k:["ship","shipping","international","country","overseas","canada","uk","delivery"],
   a:"US shipping is included in every price, tracked and insured both ways.\n\nInternational works too, but the listed price covers US postage only — you'd pay actual postage both directions plus any duties on your end. Tell me your country and Flex Factory will quote it before you commit to anything."},
  {k:["pay","payment","deposit","balance","installment","afford","finance"],
   a:"At checkout, on the same visit. Build your set, tick the terms, and you go straight through to Shopify’s secure checkout — card, Shop Pay, Apple Pay or Google Pay.\n\nFlex Factory never sees your card details, and you still get photographs of the finished set before it ships."},
  {k:["watch","watches","bezel","dial","wrist","automatic"],
   a:"The iced watch is available now. Square case with the bezel screws showing, set edge to edge by hand, automatic movement and sapphire crystal.\n\n<b>$750</b> in moissanite or <b>$3,500</b> in lab-grown diamond. Every dial and metal is the same price: eight dials, ten numeral colours, in gold, silver or rose gold.\n\nBuild it in the 3D studio on the <b>Watches</b> page. It takes about a week on the bench, then shipping, and because it is made to your spec it is a final sale."},
  {k:["g-shock","gshock","g shock","casio","apple watch","cover","covers","dw-6900","ga-2100"],
   a:"Iced moissanite covers that drop straight onto a G-Shock or Apple Watch you already own: DW-6900, GA-2100 / GA-2110, DW-6900RL-1AC and Apple Watch. Each one is cut to a single case, so order against the watch you actually have.\n\nBrass body plated in silver, gold or rose gold (depending on the design), $259 to $495. Build time is 6–8 weeks from the day you order. See the <b>G-Shock</b> page for every design."},
  {k:["dentist","dental","safe","gums","damage","teeth hurt","braces"],
   a:"No dentist visit needed — the impression putty we send is the same class of silicone a dental lab works from, and the caps are removable with no permanent modification to your teeth.\n\nTwo honest cautions: if you have braces, active dental work or gum disease, get your dentist's OK first. And don't sleep in them or eat in them — that's where problems actually come from."},
  {k:["order","buy","purchase","reserve","checkout","how do i get"],
   a:"Use the 3D studio: pick a setting, a metal, top or bottom and how many teeth, tick the terms box and hit <b>Continue to secure checkout</b>. You pay in full at Shopify checkout and your impression kit ships within one business day.\n\nWatches work the same way in the watch studio on the Watches page."},
  {k:["chain","cuban","necklace","ready","in stock","shelf","pre-made","premade"],
   a:"No chains, and no off-the-shelf grillz. Every set is cut from your own impression, which is the whole point — a pre-formed tray clicks around your gums and a custom plate doesn't.\n\nWhat else we make: the iced watch (built to order in the watch studio) and iced covers for G-Shock and Apple Watch, each cut to one model. If you're after something we don't make, email <b>"+ORDER_EMAIL+"</b> and Flex Factory will tell you straight whether it's something they can do."}
];
function kbAnswer(qRaw){
  var q=qRaw.toLowerCase(), best=null, bestScore=0;
  for(var i=0;i<KB.length;i++){
    var s=0;
    for(var j=0;j<KB[i].k.length;j++) if(q.indexOf(KB[i].k[j])>=0) s+=KB[i].k[j].length;
    if(s>bestScore){ bestScore=s; best=KB[i]; }
  }
  if(best) return best.a;
  return "I can help with grillz pricing, how the impression kit works, the four stone settings, turnaround, fit, care, shipping and payment, plus the iced watch and the G-Shock and Apple Watch covers — ask me any of those and I'll give you a straight answer.\n\nIf it's something more specific, email <b>"+ORDER_EMAIL+"</b> and Flex Factory will get back to you directly.";
}
var AI = {
  sample:null, turns:[], busy:false, ctl:null,
  rules:function(){
    var q=currentQuote();
    return "You are the Flex Factory assistant, on the Flex Factory website. Flex Factory sells custom moissanite grillz made from an at-home impression kit, an iced watch, and iced covers for G-Shock and Apple Watch.\n\n"
      +"FACTS YOU MUST USE (never invent anything beyond these):\n"
      +"- Four stone settings. Honeycomb: hexagonal lattice, stones edge to edge, cleanest and most uniform. Galaxy: many stone sizes packed tight with several large stones scattered at random, sparkle moves as you move. Mosaic: fine graduated pave built around one large centre stone with a hand-set halo on each tooth. Baguette: rectangular step cuts channel-set in rows with a micro-pave border, straight lines and long flashes.\n"
      +"- Pricing by tooth count. Honeycomb: 1=$150, 2=$275, 4=$450, 6=$650, 8=$850, 10=$1050, 12=$1200, 16=$1400, 20=$1600. Galaxy: 1=$150, 2=$300, 4=$475, 6=$700, 8=$900, 10=$1100, 12=$1300, 16=$1500, 20=$1700. Mosaic: 1=$200, 2=$275, 4=$475, 6=$675, 8=$875, 10=$1050, 12=$1200, 16=$1600, 20=$1800. Baguette runs 15% above Galaxy: 1=$175, 2=$345, 4=$545, 6=$805, 8=$1035, 10=$1265, 12=$1495, 16=$1725, 20=$1955. In-between counts are interpolated. Metal finish (yellow gold, white gold, rose gold) does NOT change price.\n"
      +"- Price includes impression kit, prepaid return mailer, fabrication and US shipping. International pays actual postage plus duties.\n"
      +"- Grillz are built in the 3D studio, 2 to 20 teeth; a single cap is a custom order. Process: order -> kit ships in 1 business day -> 5-8 business days transit -> customer takes impression with silicone putty in about 10 minutes -> prepaid mailer back -> 6-8 weeks on the bench from the day the impression arrives -> photos sent for approval -> 5-8 business days tracked shipping. Never quote less than six weeks from the impression arriving, and say the mail is on top.\n"
      +"- The customer ticks the terms in the studio and is taken straight to Shopify secure checkout to pay in full (card, Shop Pay, Apple Pay, Google Pay). Flex Factory never handles card details. There is no deposit and no payment plan — never invent one.\n"
      +"- Moissanite is silicon carbide, Mohs 9.25 (diamond 10), dispersion 0.104 (diamond 0.044) so it throws MORE colored fire than diamond. It is NOT diamond and you must never imply it is.\n"
      +"- Fit guarantee: wrong fit gets re-cut free; unusable impression gets a fresh kit free.\n"
      +"- Care: warm water, soft brush, unscented dish soap. Never boiling water, bleach, ultrasonic cleaners or alcohol. Remove to eat and to sleep. Water is fine.\n"
      +"- Braces, active dental work or gum disease: tell the customer to check with their dentist first.\n"
      +"- Grillz are only ever cut from the customer's own impression; there are no off-the-shelf grillz and no chains.\n"
      +"- Iced watch: available now. $750 moissanite or $3,500 lab-grown diamond, same price for every dial and metal. Eight dials (pave Roman, pave Arabic, red, navy, green and purple sunburst, white, skeleton), ten numeral colours, gold, silver or rose gold. Automatic movement, sapphire crystal, 304 stainless case. About one week on the bench, then shipping. Made to spec, so final sale. Built and ordered in the 3D watch studio on the Watches page.\n"
      +"- Lab-grown diamond is offered ONLY on the watch, and is sold as lab-grown, never as mined. Everything else is moissanite.\n"
      +"- Iced covers: model-specific moissanite covers for G-Shock DW-6900, GA-2100/GA-2110, DW-6900RL-1AC and Apple Watch. Brass body plated in silver, gold or rose gold depending on the design. $259 to $495. Build time 6-8 weeks from the day of order. Shown on the G-Shock page.\n"
      +"- Contact: "+ORDER_EMAIL+"\n\n"
      +"WHAT THE CUSTOMER HAS BUILT RIGHT NOW: "+(q.n?(q.n+" teeth, "+q.style.name+" setting, "+q.metal.name+", quoted "+money(q.price)):"nothing selected yet")+".\n\n"
      +"HOW TO ANSWER: short and direct, two to five sentences unless they ask for detail. Plain confident language, no hype, no emoji. If you do not know something, say so and point them at "+ORDER_EMAIL+" rather than guessing. Never invent prices, dates, policies or materials. Never claim moissanite is diamond. If they seem ready to order, tell them to use the 3D studio, tick the terms and hit Continue to secure checkout.";
  }
};
function aiPush(role,text,cls){
  var log=$("#aiLog");
  var d=document.createElement("div");
  d.className="msg "+(cls||(role==="user"?"me":"bot"));
  d.innerHTML=(cls==="sys")?esc(text):esc(text).replace(/&lt;b&gt;/g,"<b>").replace(/&lt;\/b&gt;/g,"</b>");
  log.appendChild(d); log.scrollTop=log.scrollHeight;
  return d;
}
function aiAsk(text){
  if(AI.busy||!text.trim()) return;
  AI.busy=true;
  $("#aiSend").disabled=true;
  aiPush("user",text);
  $("#aiInput").value="";
  var bubble=aiPush("assistant","");
  bubble.innerHTML='<span class="typing"><i></i><i></i><i></i></span>';
  function finish(md){
    bubble.innerHTML=esc(md).replace(/&lt;b&gt;/g,"<b>").replace(/&lt;\/b&gt;/g,"</b>");
    $("#aiLog").scrollTop=$("#aiLog").scrollHeight;
    AI.busy=false; $("#aiSend").disabled=false;
  }
  if(AI.sample){
    AI.turns.push({role:"user",content:text});
    var input=[{role:"user",content:AI.rules()}].concat(AI.turns.slice(-10));
    AI.ctl=new AbortController();
    AI.sample(input,{
      cache:false, modelTier:"quick", signal:AI.ctl.signal,
      onText:function(e){ bubble.textContent=e.text; $("#aiLog").scrollTop=$("#aiLog").scrollHeight; }
    }).then(function(res){
      AI.turns.push({role:"assistant",content:res.text});
      finish(res.text);
    }).catch(function(e){
      if(e&&e.code==="cancelled"){ finish(e.text||"Stopped."); return; }
      if(e&&(e.code==="not_granted"||e.code==="rate_limited")){
        AI.sample=null; $("#aiMode").textContent="Built-in answers";
      }
      finish(kbAnswer(text));
    });
  } else {
    setTimeout(function(){ finish(kbAnswer(text)); },260+Math.random()*260);
  }
}
var QUICK=["What does 6 teeth cost?","How does the mold kit work?","Honeycomb or Galaxy?","How long does it take?","What does a watch cost?"];
function initAI(){
  var panel=$("#aiPanel"), btn=$("#aiBtn");
  function open(){
    panel.hidden=false; btn.hidden=true;
    if(!$("#aiLog").childElementCount){
      aiPush("assistant","I'm the Flex Factory assistant. I can tell you what a set costs, how the impression kit works, which setting suits you and how long it takes, and answer questions on the iced watch and the G-Shock covers.\n\nWhat do you want to know?");
    }
    setTimeout(function(){$("#aiInput").focus();},60);
  }
  function close(){ panel.hidden=true; btn.hidden=false; if(AI.ctl) try{AI.ctl.abort();}catch(e){} }
  btn.addEventListener("click",open);
  $("#aiClose").addEventListener("click",close);
  $("#footChat").addEventListener("click",function(e){e.preventDefault();open();});
  document.addEventListener("keydown",function(e){ if(e.key==="Escape"&&!panel.hidden) close(); });
  var qb=$("#aiQuick");
  QUICK.forEach(function(q){
    var b=document.createElement("button");
    b.type="button"; b.className="qbtn"; b.textContent=q;
    b.addEventListener("click",function(){ aiAsk(q); });
    qb.appendChild(b);
  });
  $("#aiForm").addEventListener("submit",function(e){ e.preventDefault(); aiAsk($("#aiInput").value); });
  $("#aiMode").textContent="Built-in answers";
  if(window.claude&&typeof window.claude.use==="function"){
    window.claude.use("sample").then(function(s){
      if(s){ AI.sample=s; $("#aiMode").textContent="Live · powered by Claude"; }
    }).catch(function(){});
  }
}
function init(){
  $("#yr").textContent=new Date().getFullYear();
  var bs=document.getElementById("buildStamp"); if(bs) bs.textContent="build "+BUILD;
  buildArchGeometry();
  renderArch();
  renderPresets();
  renderPickers();
  PRESETS[0].set.forEach(function(n){SEL[n]=true;});
  paintArch(); updateQuote(); markPreset();
  renderSettingCards();
  if(document.getElementById("wStyle")) mountWatchHero($("#heroArt"));
  else mountVideo($("#heroArt"),"honeycomb","Honeycomb setting grillz");
  renderFaq();
  initAI();
  var rb=$("#reserveBtn"); if(rb) rb.addEventListener("click",function(){ openOrder(); });
}
if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",init);
else init();
})();
